module.exports = __webpack_public_path__ + "img/bnca.4a7321ae.png";